import createIcon from '../../createIcon';

/**
 * @component @name ImportantDevices
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgMTEuMDFMMTggMTFDMTcuNDUgMTEgMTcgMTEuNDUgMTcgMTJWMjFDMTcgMjEuNTUgMTcuNDUgMjIgMTggMjJIMjNDMjMuNTUgMjIgMjQgMjEuNTUgMjQgMjFWMTJDMjQgMTEuNDUgMjMuNTUgMTEuMDEgMjMgMTEuMDFaTTIzIDIwSDE4VjEzSDIzVjIwWk0yMCAySDJDMC44OSAyIDAgMi44OSAwIDRWMTZDMCAxNy4xIDAuODkgMTggMiAxOEg5VjIwSDdWMjJIMTVWMjBIMTNWMThIMTVWMTZIMlY0SDIwVjlIMjJWNEMyMiAyLjg5IDIxLjEgMiAyMCAyWk0xMS45NyA5TDExIDZMMTAuMDMgOUg3TDkuNDcgMTAuNzZMOC41MyAxMy42N0wxMSAxMS44N0wxMy40NyAxMy42N0wxMi41MyAxMC43NkwxNSA5SDExLjk3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImportantDevices = createIcon('ImportantDevices', [
  [
    'path',
    {
      d: 'M23 11.01L18 11C17.45 11 17 11.45 17 12V21C17 21.55 17.45 22 18 22H23C23.55 22 24 21.55 24 21V12C24 11.45 23.55 11.01 23 11.01ZM23 20H18V13H23V20ZM20 2H2C0.89 2 0 2.89 0 4V16C0 17.1 0.89 18 2 18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22 2.89 21.1 2 20 2ZM11.97 9L11 6L10.03 9H7L9.47 10.76L8.53 13.67L11 11.87L13.47 13.67L12.53 10.76L15 9H11.97Z',
      key: '1bwtl3',
    },
  ],
]);

export default ImportantDevices;
